export const td = "px-2 py-2 text-sm"
export const tdLabel = "font-bold py-2 text-gray-700 text-xs uppercase"
